<template>
    <div class="logonAccount">
        <div class="info-top">账号注销</div>
        <div class="info-down">
            <div class="info-down-contant">
                <header><i class="iconfont icon-tishi"></i>重要提示</header>
                <p>1、账号注销是不可恢复操作，请认真核对是否有遗留工作未处理或财产未清算。</p>
                <p>3、注销账号申请提交后，将在1个工作日内联系你，与核实是否本人申请注销账号。</p>
                <p>4、处理结果可在1个工作日后查询，联系电话：+86 400-808-5000。</p>
                <div class="info-down-btn">
                    <el-button type="primary">申请注销</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {

    },
    name: 'logonAccount',
    data () {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.logonAccount{
    width: 100%; height: 100%; overflow: hidden; display: flex; flex-direction: column;
    .info-top{
        height: 60px; width: 100%; margin-bottom: 16px; background: #ffffff; padding: 20px; line-height: 20px; font-size: 16px; border: 1px solid #e8e8e8;
    }
    .info-down{
        flex: 1; overflow: hidden; background: #ffffff; width: 100%; display: flex; justify-content: center; border: 1px solid #e8e8e8;
        .info-down-contant{
            height: 100%; display: inline-block; line-height: 40px;
            header{
                font-size: 16px; color: #333333; margin: 60px 0 30px;
                i{
                    font-size: 45px; margin-right: 20px; color: #3AA2EB;
                }
            }
            .info-down-btn{
                text-align: center; margin-top: 30px;
            }
            p{
                font-size: 12px;
            }
        }
    }
}
</style>
<style>
.info-down-btn .el-button{
    width: 200px; height: 44px; font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/logonAccount.vue